import { Node as ContentfulNode } from '@contentful/rich-text-types';
import { DocumentWithEmbeddedEntries } from 'libs/contentful/props';
import contentfulImageLoader from 'utils/imageLoader';
import { ContentfulAsset } from 'libs/contentful/props';
import Image from 'next/image';

const renderEmbeddedAsset = (node: ContentfulNode, children: React.ReactNode, content: DocumentWithEmbeddedEntries) => {
  const asset = node.data.target;
  const blockAssets = (content?.links?.assets as { block?: ContentfulAsset[] })?.block || [];
  const foundAsset = blockAssets.find((i: { sys: { id: string } }) => i.sys.id === asset.sys.id);

  if (!foundAsset) return null;

  const optimizedAsset = contentfulImageLoader({
    src: foundAsset.url,
    width: 800,
  });

  return (
    <figure>
      <Image
        src={optimizedAsset}
        alt={foundAsset.title || ''}
        width={foundAsset.width}
        height={foundAsset.height}
        data-testid="embeddedAsset"
        sizes="(max-width: 375px) 100vw, 500px"
      />
      {foundAsset.description && (
        <figcaption className="mt-4 text-xs" data-testid="embeddedAssetDescription">
          {foundAsset.description}
        </figcaption>
      )}
    </figure>
  );
};

export default renderEmbeddedAsset;
